// @flow
export const WaybillGenerationTypeEnum = Object.freeze({
    LIST: 'LIST',
    MANUAL: 'MANUAL'
});

export type WaybillGenerationType = $Keys<typeof WaybillGenerationTypeEnum>;
